import React, { useEffect, useState } from "react";
import thongBaoImage from "../assets/img/ChienMaTVSI.jpg";
const PromoPopup = () => {
   const [showPopup, setShowPopup] = useState(true);
   const [config, setConfig] = useState({ isLinkImg: "", isLinkPopup: "" });

   //  useEffect(() => {
   //    setShowPopup(true); // Hiển thị popup khi trang tải
   //  }, []);
   // useEffect(() => {
   //    // Hiển thị popup khi trang tải và tự động đóng sau 10 giây
   //    const timer = setTimeout(() => {
   //       setShowPopup(false);
   //    }, 5000);

   //    // Xoá timer nếu component bị unmount
   //    return () => clearTimeout(timer);
   // }, []);

   // Cấu hình động show popup trên máy từ server
   useEffect(() => {
      // 1) Nếu script ngoài đã nạp config (từ window)
      if (window.__CONFIG__) {
         setConfig({
            isLinkImg: window.__CONFIG__.isLinkImg || "",
            isLinkPopup: window.__CONFIG__.isLinkPopup || "",
         });
         return;
      }

      // 2) Fetch từ /data/configs.json
      let mounted = true;
      async function loadConfig() {
         try {
            const res = await fetch("/data/configs.json?t=" + Date.now(), { cache: "no-store", "Content-Type": "application/json" });
            if (!res.ok) return;
            const json = await res.json();
            if (mounted) {
               setConfig({
                  isLinkImg: json.isLinkImg || "",
                  isLinkPopup: json.isLinkPopup || "",
               });
            }
         } catch (e) {
            /* ignore */
         }
      }
      loadConfig();

      // 3) Lắng nghe event update (nếu có script injection đẩy message)
      const onConfigUpdate = (ev) => {
         if (ev?.detail) {
            setConfig({
               isLinkImg: ev.detail.isLinkImg || "",
               isLinkPopup: ev.detail.isLinkPopup || "",
            });
         }
      };
      window.addEventListener("config:update", onConfigUpdate);

      return () => {
         mounted = false;
         window.removeEventListener("config:update", onConfigUpdate);
      };
   }, []);

   const handleClose = () => {
      setShowPopup(false);
   };

   if (!showPopup) return null;

   return (
      <div style={styles.overlay}>
         <div style={styles.popup}>
            <button onClick={handleClose} style={styles.closeBtn}>
               X
            </button>
            <a href={config.isLinkPopup || "https://www.tvsi.com.vn/News/news-detail-2584.html"}>
               <img src={config.isLinkImg || "https://img.tvsi.com.vn/img-prs/TVSI_PRS_POPUP.jpg"} alt="Chương trình khuyến mãi" style={styles.image} />
            </a>
            {/* <a href="https://www.tvsi.com.vn/News/news-detail-2570.html" >
               <img src={thongBaoImage} style={styles.image} />
            </a> */}
         </div>
      </div>
   );
};
const styles = {
   overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
   },
   popup: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "0",
      borderRadius: "10px",
      overflow: "hidden",
      maxWidth: "725px",
      width: "90%",
   },
   closeBtn: {
      position: "absolute",
      top: "10px",
      right: "10px",
      zIndex: 10,
      background: "transparent",
      border: "none",
      fontSize: "18px",
      cursor: "pointer",
      color: "rgba(0,0,0,0.5)",
   },
   image: {
      width: "100%",
      height: "auto",
      display: "block",
   },
};
export default PromoPopup;
